import React from 'react'
import ErrorBoundary from '../ui/error-boundary'
import RemoteRequest from '../remote-request'

// This function takes a component...
const withAsyncLoad = (dataName, WrappedComponent, endpointFromProps, testFetch = false) => {
  // ...and returns another component...
  class ComponentWithAsyncLoad extends React.Component {
    constructor(props) {
      super(props)
      this.request = null
      this.callEndpoint(endpointFromProps(props), props.remote_request)
    }

    componentWillUnmount() {
      this.props.remote_request.cancel()
    }

    componentDidUpdate(prevProps) {
      const oldEndpoint = endpointFromProps(prevProps)
      const currentEndpoint = endpointFromProps(this.props)

      if (oldEndpoint !== currentEndpoint) {
        this.callEndpoint(currentEndpoint, this.props.remote_request)
      }
    }

    callEndpoint(endpoint, remote_request) {
      if (!endpoint) {
        console.error(
          'No api endpoint passed to LocalAsyncStore. You might not be passing the path to your "refresh_RESOURCE_NAME" method'
        )
      }

      return (remote_request || this.props.remote_request).submit(
        process.env.REACT_APP_API_HOST + endpoint,
        {
          method: 'GET',
          jsonAPI: true,
        }
      )
    }

    render() {
      const data = {}
      data[dataName] = { ...this.props.remote_request.state }
      data[`refresh_${dataName}`] = this.callEndpoint.bind(this)

      // ... and renders the wrapped component with the fresh data!
      // Notice that we pass through any additional props
      return (
        <ErrorBoundary>
          <WrappedComponent {...data} {...this.props} />
        </ErrorBoundary>
      )
    }
  }

  return RemoteRequest(ComponentWithAsyncLoad, testFetch)
}

export default withAsyncLoad



// WEBPACK FOOTER //
// ./src/local-async-store/index.js